import {$, $$} from "./Dom.ts";
import {createErrorNotification} from "../../portail/js/Notifications.ts";

export function initSort(container: HTMLElement|null|undefined) {
    if(container) {
        function updateSortIcon() {
            requestAnimationFrame(() => {
                if(container) $$('.sort', container).forEach((element: HTMLElement) => {
                    const orderDescending = element.classList.contains('desc')
                    const orderAscending = element.classList.contains('asc')
                    const icon = $('i', element)
                    if (icon) {
                        icon.classList.remove('remix-sort-asc', 'remix-sort-desc', 'remix-sort')
                        if (orderDescending || orderAscending) {
                            if (orderDescending) {
                                icon.classList.add('remix-sort-desc')
                            } else {
                                icon.classList.add('remix-sort-asc')
                            }
                        } else {
                            icon.classList.add('remix-sort')
                        }
                    }
                })
            })
        }

        $$('.sort', container).forEach((element: HTMLElement) => {
            element.addEventListener('click', updateSortIcon)
        })
    } else {
        createErrorNotification({
            message: "l'initialisation du tri a besoin d'un container existant"
        })
    }
}